import React from "react";
import { Button } from "antd";
import cartIcon from "../../../assets/icons/shoppingCartWhiteOutlined.svg";
import styles from "./GroceryDelivery.module.scss";

type Props = {
  itemCount: number;
  onClick: () => void;
};

function FloatingCartButton({ itemCount, onClick }: Props) {
  return (
    <Button
      type="primary"
      icon={<img src={cartIcon} alt="cart" />}
      size="large"
      onClick={onClick}
      className={styles.floatingCartBtn}
    >
      {!!itemCount && itemCount}
    </Button>
  );
}

export default FloatingCartButton;
